import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextInput from '../../components/TextInput';
import FileUpload from '../../components/FileUpload'; // Changed from FileInput to FileUpload
import Button from '../../components/Button';
import SkeletonLoader from '../../components/SkeletonLoader';
import clientApi from '../../api/clientApi';
import { useToast } from '../../contexts/ToastContext';
import { ROUTES } from '../../constants';

const AddClient = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    logo: null,
  });

  const handleChange = (e) => {
    const { name, value, type, files, checked } = e.target; // Destructure 'checked' here
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : (type === 'file' ? files[0] : value),
    });
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setValidationErrors({});

    const data = new FormData();
    data.append('name', formData.name);
    if (formData.logo) {
      data.append('logo', formData.logo);
    }

    try {
      await clientApi.createClient(data);
      addToast('Client created successfully!', 'success');
      navigate(ROUTES.CLIENTS);
    } catch (err) {
      console.error('Failed to add client:', err);
      if (err.response && err.response.status === 422) {
        setValidationErrors(err.response.data.errors || {});
        addToast(err.response.data.message || 'Validation failed. Please check your input.', 'error');
      } else {
        addToast(err.response?.data?.message || 'Failed to add client. Please try again.', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-800 rounded-lg shadow-md text-text-white">
      <h1 className="text-3xl font-bold mb-6">Add New Client</h1>
      {loading ? (
        <SkeletonLoader type="form" />
      ) : (
        <form onSubmit={handleSubmit}>
          <TextInput
            label="Client Name"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
            required={true}
            placeholder="Client Name"
            error={validationErrors?.name?.[0]}
          />
          <FileUpload // Changed to FileUpload
            label="Client Logo"
            name="logo"
            id="logo"
            onChange={handleChange}
            error={validationErrors?.logo?.[0]}
            required={true}
            currentFileUrl={null} // No current logo for Add form
            onRemoveFile={null} // No remove functionality for Add form
            fileType="image"
            fileName="Logo"
          />
          <div className="flex items-center justify-between mt-6">
            <Button
              type="submit"
              className="bg-accent-red hover:bg-red-700 text-white"
              loading={loading}
            >
              Add Client
            </Button>
            <Button
              type="button"
              onClick={() => navigate(ROUTES.CLIENTS)}
              className="bg-gray-500 hover:bg-gray-600 text-white"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddClient;